import { formatDate } from "utils/basic";

import type { DateDisplayMode } from "./DateDisplay.types";

export function getDisplayDate(
  mode: DateDisplayMode,
  dateModified?: string,
  dateCreated?: string,
): string {
  const currentDate = new Date().toISOString();
  const resolvedMode = !dateModified && !dateCreated ? "current" : mode;

  switch (resolvedMode) {
    case "created":
      return dateCreated ?? currentDate;
    case "modified":
      return dateModified ?? currentDate;
    default:
      return currentDate;
  }
}

export function getHintText(
  dateCreated?: string,
  dateModified?: string,
): string {
  return [
    dateCreated && "Создано: " + formatDate(dateCreated),
    dateModified && "Изменено: " + formatDate(dateModified),
  ]
    .filter(Boolean)
    .join("\n");
}
